import * as ActionTypes from '../constants/actionTypes'
import {
  sellerChatCreate,
  sellerChatUpdate,
  sellerChatDelete,
  sellerChatsGet, sellerUpdate,
  sellerUpdateChatToken,
} from '../api/seller'
import { TYPE_CHAT_LABELS } from '../shared/utils/constant'
import { generateChatbotUrl } from '../shared/utils'

export const editForm = formFieldsChange => ({
  type: ActionTypes.SELLERCHATFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.SELLERCHATFORM_ENTER_RESET,
})

export const fetchItem = values => async (dispatch) => {
  const {
    sellerToken,
    sellerId,
    messengerType,
  } = values
  dispatch({ type: ActionTypes.SELLERCHATFORM_FETCHITEM_LOAD })
  let item
  try {
    item = await sellerChatsGet({
      sellerId,
      sellerToken,
      messengerType,
      current: 1,
      pageSize: 12,
    })
    dispatch({
      type: ActionTypes.SELLERCHATFORM_FETCHITEM_SUCCEED,
      item,
    })
    dispatch({
      type: ActionTypes.SELLERCHATFORM_EDITFORM_CHANGE,
      field: {
        id: {
          name: 'idnum',
          value: item.idnum,
        },
        n_type: {
          name: 'n_type',
          value: item.messengerType,
        },
        s_api_token: {
          name: 's_api_token',
          value: item.apiToken,
        },
        s_url: {
          name: 's_url',
          value: item.url,
        },
        s_name: {
          name: 's_name',
          value: item.messengerId,
        },
        s_btn_color: {
          name: 's_btn_color',
          value: item.additionalData ? item.additionalData.btnColor || '' : '',
        },
        s_txt_color:
          {
            name: 's_txt_color',
            value: item.additionalData ? item.additionalData.txtColor || '' : '',
          },
        s_url_image: {
          name: 's_url_image',
          value: item.additionalData ? item.additionalData.avatarUrl || '' : '',
        },
        s_welcome_message: {
          name: 's_welcome_message',
          value: item.additionalData ? item.additionalData.welcomeMessage || '' : '',
        },
        s_conf_token: {
          name: 's_conf_token',
          value: item.additionalData ? item.additionalData.confirmationToken || '' : '',
        },
        s_bck_color: {
          name: 's_bck_color',
          value: item.additionalData ? item.additionalData.bgColor || '' : '',
        },

      },
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.SELLERCHATFORM_FETCHITEM_FAIL,
      fetchItemError: 'Ошибка получения данных по чатам торговой сети.',
    })
  }
}

export const createItem = values => async (dispatch) => {
  const {
    sellerId,
    maxbonusSellerId,
    s_name: messengerId,
    n_type: messengerType,
    s_api_token: apiToken,
    s_url: url,
    sellerName,
    seller,
    ...item
  } = values
  const messengerTypeLabel = TYPE_CHAT_LABELS[Number(messengerType)].toLowerCase()
  dispatch({ type: ActionTypes.SELLERCHATFORM_CREATEITEM_LOAD })
  let chat
  try {
    chat = await sellerChatCreate({
      sellerName,
      sellerId,
      messengerId,
      maxbonusSellerId,
      messengerType: messengerTypeLabel,
      apiToken,
      url: generateChatbotUrl(messengerType, messengerId) || '',
      additionalData: {
        btnColor: item.s_btn_color || '',
        confirmationToken: item.s_conf_token || '',
        bgColor: item.s_bck_color || '',
        txtColor: item.s_txt_color || '',
        avatarUrl: item.s_url_image || '',
        welcomeMessage: item.s_welcome_message || '',
      },
    })
    console.log('fetch')
    if (chat.token) {
      await sellerUpdateChatToken({
        ...seller,
        s_chatbot_token: chat.token,
      })
    }
    dispatch({ type: ActionTypes.SELLERCHATFORM_CREATEITEM_SUCCEED })
    if (chat.token) window.location.reload()
  } catch (error) {
    dispatch({
      type: ActionTypes.SELLERCHATFORM_CREATEITEM_FAIL,
      createItemError: error.message || 'Ошибка при создании чатбота',
    })
  }
}

export const editItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.SELLERCHATFORM_EDITITEM_LOAD })
  const {
    sellerId: maxbonusSellerId,
    sellerToken: sellerId,
    s_name: messengerId,
    s_url: url,
    ...item
  } = params
  try {
    await sellerChatUpdate({
      sellerId,
      messengerId,
      maxbonusSellerId,
      url,
      additionalData: {
        btnColor: item.s_btn_color || '',
        confirmationToken: item.s_conf_token || '',
        bgColor: item.s_bck_color || '',
        txtColor: item.s_txt_color || '',
        avatarUrl: item.s_url_image || '',
        welcomeMessage: item.s_welcome_message || '',
      },
    })
    dispatch({ type: ActionTypes.SELLERCHATFORM_EDITITEM_SUCCEED })
  } catch (error) {
    dispatch({
      type: ActionTypes.SELLERCHATFORM_EDITITEM_FAIL,
      editItemError: 'Ошибка изменения данных.',
    })
  }
  //   .then(() => {
  //   })
  //   .catch((err) => {
  //     dispatch({
  //       type: ActionTypes.SELLERCHATFORM_EDITITEM_FAIL,
  //       editItemError: 'Ошибка изменения данных.',
  //     })
  //   })
}

export const deleteItem = values => async (dispatch) => {
  dispatch({ type: ActionTypes.SELLERCHATFORM_DELETEITEM_LOAD })
  const {
    apiToken,
    sellerId,
    sellerToken,
  } = values
  try {
    await sellerChatDelete({
      apiToken,
      sellerId,
      sellerToken,
    })
    dispatch({ type: ActionTypes.SELLERCHATFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.SELLERPOINTFORM_ENTER_RESET })
  } catch (eroor) {
    dispatch({
      type: ActionTypes.SELLERCHATFORM_DELETEITEM_FAIL,
      deleteItemError: 'Ошибка удаления чата торговой сети.',
    })
  }
  // sellerChatDelete(values)
  //   .then(() => {
  //     dispatch({ type: ActionTypes.SELLERCHATFORM_DELETEITEM_SUCCEED })
  //     // dispatch({ type: ActionTypes.SELLERPOINTFORM_ENTER_RESET })
  //   })
  //   .catch((err) => {
  //     dispatch({
  //       type: ActionTypes.SELLERCHATFORM_DELETEITEM_FAIL,
  //       deleteItemError: 'Ошибка удаления чата торговой сети.',
  //     })
  //   })
}



// WEBPACK FOOTER //
// src/actions/sellerChatForm.js